<template>
    <div class="speed-data-section">
        <!-- 模块标题 -->

        <h3>3.1、车速数据</h3>

        <!-- ECharts 柱状图容器 -->
        <div ref="speedChart" class="chart-container" style="height: 280px;margin-top: 15px;"></div>
        <div class="table-caption">图表1</div>
        <!-- 横向多列表格（完全匹配截图） -->
        <el-table :data="speedTableData" size="mini" border :cell-class-name="tableCellClassName"
            style="width: 100%; margin-top: 15px;">
            <!-- 动态渲染列（车速区间） -->
            <el-table-column label="车速(km/h)" prop="label" align="center">

            </el-table-column>
            <!-- 时间列 -->
            <el-table-column label="时间(小时)" prop="time" align="center" />
            <!-- 百分比列 -->
            <el-table-column label="百分比(%)" prop="percent" align="center" />
        </el-table>
        <div class="table-caption">数据表1</div>

        <!-- 说明文本 -->
        <div class="note">
            <p>说明：</p>
            <p>1.按相关法规规定, 公路车最高车速不得高于100km/h, 专用校车最高车速不得高于80km/h, 公交车最高车速小于70km/h;</p>
            <p>2.采集期内的最高车速为{{ MaxSpeed }}km/h。</p>
        </div>
    </div>
</template>

<script>

export default {
    name: "vehicle_speed_data",
    props: {
        speedChart: {
            type: Array,
            default: () => ([])
        },
        basicInfo: {
            type: Object,
            default: () => ({})
        }
    },

    watch: {
        speedChart: {
            handler(newVal, oldVal) {
                if (newVal && newVal.length) {
                    this.updateChart();
                }
            },
            deep: true
        },
        basicInfo: {
            handler(newVal, oldVal) {
                if (newVal) {
                    this.MaxSpeed = newVal.MaxSpeed;
                }
            },
            deep: true
        }
    },
    data() {
        return {
            speedTableData: [],
            myChart: undefined,
            MaxSpeed: 0,
        };
    },
    mounted() {
        this.initSpeedChart();
    },
    methods: {
        updateChart() {
            //数据更新，表格数据和图表数据
            var totalTime = 0;
            // 计算累计时间
            var tableData = [];
            var xAxisData = [];
            var seriesData = [];
            this.speedChart.forEach(item => {
                totalTime += parseFloat(item.WorkHour);
                tableData.push({
                    label: item.SpeedName,
                    time: item.WorkHour,
                    percent: item.PointPerCent
                });
                xAxisData.push(item.SpeedName);
                seriesData.push(parseFloat(item.PointPerCent));
            });
            tableData.push({
                label: '累计',
                time: totalTime.toFixed(2),
                percent: '100'
            });
            this.speedTableData = tableData;

            // 图表配置
            const option = {
                xAxis: {
                    data: xAxisData,
                },
                series: [{
                    data: seriesData,
                }
                ]
            };

            this.myChart.setOption(option);
        },
        tableCellClassName({ row, column, rowIndex, columnIndex }) {
            // 对车速≥110的区间应用警告样式
            const warningLabels = ['≤110', '≤120', '>120'];
            if (warningLabels.includes(row.label)) {
                return "cell-header-warning";
            } else if (columnIndex === 0) {
                return 'cell-header';
            }
            // 对其他区间应用普通样式
            return "";
        },
        // 合并单元格方法
        initSpeedChart() {
            const chartDom = this.$refs.speedChart;
            this.myChart = echarts.init(chartDom);

            // 图表配置
            const option = {
                title: {
                    text: '',
                    left: 'center',

                },
                backgroundColor: '#E2F0FF',
                tooltip: {
                    trigger: 'axis',
                    axisPointer: { type: 'shadow' }
                },
                grid: {
                    left: '3%',
                    bottom: '8%',
                    right: '3%',
                    containLabel: true
                },
                xAxis: {
                    name: '车速(km/h)',
                    nameLocation: 'center',
                    nameGap: 40,
                    type: 'category',
                    data: [],
                    axisLabel: {
 rotate: 45,
                        interval: 0
                    }
                },
                yAxis: {
                    type: 'value',
                    name: '百分比(%)'
                },
                series: [
                    {
                        data: [],
                        type: 'bar',
                        label: {
                            show: true,
                            position: 'top'
                        },
                        itemStyle: {
                            color: '#409EFF' // 柱状图颜色（ElementUI 主色）
                        }
                    }
                ]
            };

            this.myChart.setOption(option);

            // 监听窗口 resize，自适应图表
            window.addEventListener('resize', () => {
                this.myChart.resize();
            });
        }
    }
};
</script>
<style scoped></style>